import { updateProjectMember } from '@/services/member/member'
import { Member } from '@/services/member/member.model'
import { PROJECT_ACCOUNT_TYPES } from '@/utils/constants'
import { useRequest } from 'ahooks'
import { Form, Modal, ModalProps, Select } from 'antd'
import { ColumnFilterItem } from 'antd/es/table/interface'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
export const accountTypeFilters: ColumnFilterItem[] = Object.keys(PROJECT_ACCOUNT_TYPES).map((key) => ({
  text: (PROJECT_ACCOUNT_TYPES[key] as string).toUpperCase(),
  value: key
}))

interface EditMemberModalProps extends ModalProps {
  projectId: number
  onSuccess: () => void
  member: Member.ProjectMember
}

function EditMemberModal(props: EditMemberModalProps) {
  const { projectId, member, onSuccess, onCancel } = props
  const [visible, setVisible] = useState(true)
  const [form] = Form.useForm()
  const { loading, run } = useRequest(
    (values) => updateProjectMember(projectId, member.memberId, values),
    {
      manual: true,
      onSuccess: () => {
        handleCancel()
        onSuccess()
      }
    }
  )

  const handleCancel = (e?) => {
    setVisible(false)
    onCancel?.(e)
  }

  useEffect(() => {
    if (member) {
      const roleIds = member.roles?.map((item) => item.id)
      form.setFieldsValue({ roles: roleIds, accountType: member.accountType })
    }
  }, [])

  return (
    <Modal
      {...props}
      width={500}
      visible={visible}
      onCancel={handleCancel}
      confirmLoading={loading}
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        onFinish={(values) => {
          run(values)
        }}
      >
        <Form.Item label='Account type' name='accountType'>
          <Select>
            {accountTypeFilters.map((item) => (
              <Select.Option value={item.value} key={item.value as number}>
                {item.text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

      </Form>
    </Modal>
  )
}

EditMemberModal.show = (props: EditMemberModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const clean = () => {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }

  ReactDOM.render(
    <EditMemberModal
      {...props}
      onCancel={(e) => {
        props.onCancel?.(e)
        clean()
      }}
    />,
    div
  )
}

export default EditMemberModal
